import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 13 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M5.102.295C5.484.102 5.969 0 6.5 0s1.015.102 1.398.295c.382.194.705.513.705.938v.222h1.338c.211 0 .382.162.382.363v.727h1.721c.523 0 .956.412.956.91V15.09c0 .497-.433.909-.956.909H.956c-.523 0-.956-.412-.956-.91V3.456c0-.498.433-.91.956-.91h1.72v-.727c0-.2.172-.363.383-.363h1.338v-.222c0-.425.323-.744.705-.938zM3.023 6.727a.39.39 0 0 0-.322.197.35.35 0 0 0 .018.364.39.39 0 0 0 .34.167h6.882a.39.39 0 0 0 .336-.18.35.35 0 0 0 0-.367.39.39 0 0 0-.336-.18zm-.322 2.56a.39.39 0 0 1 .358-.196h6.882a.39.39 0 0 1 .336.18c.07.113.07.254 0 .367a.39.39 0 0 1-.336.18H3.06a.39.39 0 0 1-.34-.167.35.35 0 0 1-.019-.364m.322 2.167a.39.39 0 0 0-.322.197.35.35 0 0 0 .018.364c.074.11.203.173.34.167h5.353a.39.39 0 0 0 .335-.18.35.35 0 0 0 0-.367.39.39 0 0 0-.335-.18zM7.54.938C7.3.818 6.922.728 6.5.728s-.8.09-1.04.21c-.239.121-.298.239-.298.296v.585a.374.374 0 0 1-.383.364H3.441v1.454h6.118V2.182H8.22a.373.373 0 0 1-.383-.364v-.585c0-.057-.059-.175-.298-.296z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }